import React from "react";

const Dialogue = ({ type, title, description, visible, onCancel }) => {
  let dialogueClass = "card dialogue dialogue--" + type;
  return (
    <div class={dialogueClass} style={{ display: visible ? "block" : "none" }}>
      <div class="confirmation__content">
        <h2 class="card__heading confirmation__heading">{title}</h2>
        <p>{description}</p>
        <button className="btn btn--accent" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default Dialogue;
